import { defineMessages } from 'react-intl';

// All known field names
export const APPROVED_ATTRIBUTE_NAME =                        'Approved';
export const APPROVED_BY_ATTRIBUTE_NAME =                     'Approved By';
export const ASSET_ID_ATTRIBUTE_NAME =                        'asset_id';
export const AV_PREVIEW_STATUS_ATTRIBUTE_NAME =               'com.extensis.portfolio.AVPreviewStatus';
export const BIT_DEPTH_ATTRIBUTE_NAME =                       'Bit Depth';
export const CATALOGED_ATTRIBUTE_NAME =                       'Cataloged';
export const CATALOGED_BY_ATTRIBUTE_NAME =                    'Cataloged By';
export const CHECK_OUT_STATUS_ATTRIBUTE_NAME =                'com.extensis.portfolio.checkoutStatus';
export const CHECK_OUT_USER_ATTRIBUTE_NAME =                  'com.extensis.portfolio.checkedOutBy';
export const CLIENT_NAME_ATTRIBUTE_NAME =                     'Client Name';
export const COLOR_MODE_ATTRIBUTE_NAME =                      'Color Mode';
export const COLOR_PROFILE_ATTRIBUTE_NAME =                   'Color Profile';
export const COPYRIGHT_ATTRIBUTE_NAME =                       'Copyright';
export const CORRUPT_FILE_ATTRIBUTE_NAME =                    'CorruptFile';
export const CREATED_ATTRIBUTE_NAME =                         'Created';
export const CREATOR_APP_ATTRIBUTE_NAME =                     'Creator Application';
export const CUSTOM_THUMBNAIL_ATTRIBUTE_NAME =                'Custom Thumbnail';
export const DESCRIPTION_WRITER_ATTRIBUTE_NAME =              'Description Writer';
export const DIR_PATH_ATTRIBUTE_NAME =                        'Directory Path';
export const DOC_TITLE_ATTRIBUTE_NAME =                       'Document Title';
export const DOCUMENT_TEXT_ATTRIBUTE_NAME =                   'Document Text';
export const EXIF_APERTURE_ATTRIBUTE_NAME =                   'EXIF - Aperture';
export const EXIF_CAMERA_MAKE_ATTRIBUTE_NAME =                'EXIF - Camera Make';
export const EXIF_CAMERA_MODEL_ATTRIBUTE_NAME =               'EXIF - Camera Model';
export const EXIF_DATE_DIGITIZED_ATTRIBUTE_NAME =             'EXIF - Date Digitized';
export const EXIF_DATE_TAKEN_ATTRIBUTE_NAME =                 'EXIF - Date Taken';
export const EXIF_EXPOSURE_BIAS_ATTRIBUTE_NAME =              'EXIF - Exposure Bias';
export const EXIF_EXPOSURE_TIME_ATTRIBUTE_NAME =              'EXIF - Exposure Time';
export const EXIF_F_NUMBER_ATTRIBUTE_NAME =                   'EXIF - F-Number';
export const EXIF_FLASH_ATTRIBUTE_NAME =                      'EXIF - Flash';
export const EXIF_FOCAL_LENGTH_ATTRIBUTE_NAME =               'EXIF - Focal Length';
export const EXIF_GPS_ALTITIUDE_ATTRIBUTE_NAME =              'EXIF - GPS Altitude';
export const EXIF_GPS_LATITUDE_ATTRIBUTE_NAME =               'EXIF - GPS Latitude';
export const EXIF_GPS_LONGITUDE_ATTRIBUTE_NAME =              'EXIF - GPS Longitude';
export const EXIF_ISO_SPEED_ATTRIBUTE_NAME =                  'EXIF - ISO Speed';
export const EXIF_LIGHT_SOURCE_ATTRIBUTE_NAME =               'EXIF - Light Source';
export const EXIF_METERING_MODE_ATTRIBUTE_NAME =              'EXIF - Metering Mode';
export const EXIF_SHUTTER_SPEED_ATTRIBUTE_NAME =              'EXIF - Shutter Speed';
export const EXIF_WHITE_BALANCE_ATTRIBUTE_NAME =              'EXIF - White Balance';
export const EXTENSION_WIN_ATTRIBUTE_NAME =                   'Extension Win';
export const FILE_DESCRIPTION_ATTRIBUTE_NAME =                'File Description';
export const FILE_SIZE_ATTRIBUTE_NAME =                       'File Size';
export const FILENAME_ATTRIBUTE_NAME =                        'Filename';
export const FLAGS_ATTRIBUTE_NAME =                           'Flags';
export const FONTSENSE_FAMILY_ATTRIBUTE_NAME =                'Extensis Font Sense - Family';
export const FONTSENSE_FONT_KIND_ATTRIBUTE_NAME =             'Extensis Font Sense - Font Type';
export const FONTSENSE_CHECKSUM_ATTRIBUTE_NAME =              'Extensis Font Sense - Font Sense ID';
export const FONTSENSE_FOUNDRY_ATTRIBUTE_NAME =               'Extensis Font Sense - Foundry';
export const FONTSENSE_POSTSCRIPT_NAME_ATTRIBUTE_NAME =       'Extensis Font Sense - PostScript Name';
export const FONTSENSE_VERSION_ATTRIBUTE_NAME =               'Extensis Font Sense - Version';
export const FULLY_CATALOGED_ATTRIBUTE_NAME =                 'FullyCataloged';
export const GEOMETRY_ATTRIBUTE_NAME =                        'Geometry';
export const GEO_COORDINATE_REF_ATTRIBUTE_NAME =              'Geo - Coordinate Reference System';
export const GEO_TYPE_ATTRIBUTE_NAME =                        'Geo - Type';
export const GEO_X_ORIGIN_ATTRIBUTE_NAME =                    'Geo - X-Origin';
export const GEO_Y_ORIGIN_ATTRIBUTE_NAME =                    'Geo - Y-Origin';
export const GEO_X_RES_ATTRIBUTE_NAME =                       'Geo - X-Resolution';
export const GEO_Y_RES_ATTRIBUTE_NAME =                       'Geo - Y-Resolution';
export const GEO_X_ROT_ATTRIBUTE_NAME =                       'Geo - X-Rotation';
export const GEO_Y_ROT_ATTRIBUTE_NAME =                       'Geo - Y-Rotation';
export const GEO_NATIVE_BOUNDS_ATTRIBUTE_NAME =               'Geo - Native Bounds';
export const GEO_WGS84_BOUNDS_ATTRIBUTE_NAME =                'Geo - WGS 84 Bounds';
export const GEO_EPGS_CODE_ATTRIBUTE_NAME =                   'Geo - EPSG Code';
export const HEIGHT_ATTRIBUTE_NAME =                          'Height';
export const HORIZONTAL_RESOLUTION_ATTRIBUTE_NAME =           'Horizontal Resolution';
export const IPTC_AUTHOR_TITLE_ATTRIBUTE_NAME =               'IPTC - Author Title';
export const IPTC_CATEGORY_ATTRIBUTE_NAME =                   'IPTC - Category';
export const IPTC_CATEGORIES_ATTRIBUTE_NAME =                 'IPTC - Categories';
export const IPTC_CITY_ATTRIBUTE_NAME =                       'IPTC - City';
export const IPTC_COPYRIGHT_INFO_URL_ATTRIBUTE_NAME =         'IPTC - Copyright Info URL';
export const IPTC_COPYRIGHT_NOTICE_ATTRIBUTE_NAME =           'IPTC - Copyright Notice';
export const IPTC_COUNTRY_ATTRIBUTE_NAME =                    'IPTC - Country';
export const IPTC_COUNTRY_CODE_ATTRIBUTE_NAME =               'IPTC - Country Code';
export const IPTC_CREATOR_ATTRIBUTE_NAME =                    'IPTC - Creator';
export const IPTC_CREDIT_ATTRIBUTE_NAME =                     'IPTC - Credit';
export const IPTC_DATE_CREATED_ATTRIBUTE_NAME =               'IPTC - Date Created';
export const IPTC_EVENT_ATTRIBUTE_NAME =                      'IPTC - Event';
export const IPTC_HEADLINE_ATTRIBUTE_NAME =                   'IPTC - Headline';
export const IPTC_INSTRUCTIONS_ATTRIBUTE_NAME =               'IPTC - Instructions';
export const IPTC_SOURCE_ATTRIBUTE_NAME =                     'IPTC - Source';
export const IPTC_STATE_PROVINCE_ATTRIBUTE_NAME =             'IPTC - State/Province';
export const IPTC_SUPPLEMENTAL_CATEGORIES_ATTRIBUTE_NAME =    'IPTC - Supplemental Categories';
export const IPTC_SUPPLEMENTAL_CATEGORY_ATTRIBUTE_NAME =      'IPTC - Supplemental Category';
export const IPTC_TITLE_ATTRIBUTE_NAME =                      'IPTC - Title';
export const IPTC_TRANSMISSION_REFERENCE_ATTRIBUTE_NAME =     'IPTC - Transmission Reference';
export const IPTC_URGENCY_ATTRIBUTE_NAME =                    'IPTC - Urgency';
export const IPTC_CREATOR_ADDRESS_ATTRIBUTE_NAME =            'IPTC - Creator Address';
export const IPTC_CORE_CREATOR_ADDRESS_ATTRIBUTE_NAME =       'IPTC:Core - Creator Address';
export const IPTC_CREATOR_CITY_ATTRIBUTE_NAME =               'IPTC - Creator City';
export const IPTC_CORE_CREATOR_CITY_ATTRIBUTE_NAME =          'IPTC:Core - Creator City';
export const IPTC_CREATOR_COUNTRY_ATTRIBUTE_NAME =            'IPTC - Creator Country';
export const IPTC_CORE_CREATOR_COUNTRY_ATTRIBUTE_NAME =       'IPTC:Core - Creator Country';
export const IPTC_CREATOR_EMAIL_ATTRIBUTE_NAME =              'IPTC - Creator Email';
export const IPTC_CORE_CREATOR_EMAIL_ATTRIBUTE_NAME =         'IPTC:Core - Creator Email';
export const IPTC_CREATOR_JOB_TITLE_ATTRIBUTE_NAME =          'IPTC - Creator Job Title';
export const IPTC_CREATOR_PHONE_ATTRIBUTE_NAME =              'IPTC - Creator Phone';
export const IPTC_CORE_CREATOR_PHONE_ATTRIBUTE_NAME =         'IPTC:Core - Creator Phone';
export const IPTC_CREATOR_POSTAL_CODE_ATTRIBUTE_NAME =        'IPTC - Creator Postal Code';
export const IPTC_CORE_CREATOR_POSTAL_CODE_ATTRIBUTE_NAME =   'IPTC:Core - Creator Postal Code';
export const IPTC_CREATOR_STATE_PROVINCE_ATTRIBUTE_NAME =     'IPTC - Creator State/Province';
export const IPTC_CORE_CREATOR_STATE_PROVINCE_ATTRIBUTE_NAME = 'IPTC:Core - Creator State/Province';
export const IPTC_CREATOR_WEB_URL_ATTRIBUTE_NAME =            'IPTC - Creator Web URL';
export const IPTC_CORE_CREATOR_WEB_URL_ATTRIBUTE_NAME =       'IPTC:Core - Creator Web URL';
export const IPTC_INTELLECTUAL_GENRE_ATTRIBUTE_NAME =         'IPTC - Intellectual Genre';
export const IPTC_CORE_INTELLECTUAL_GENRE_ATTRIBUTE_NAME =    'IPTC:Core - Intellectual Genre';
export const IPTC_LOCATION_ATTRIBUTE_NAME =                   'IPTC - Location';
export const IPTC_CORE_LOCATION_ATTRIBUTE_NAME =              'IPTC:Core - Location';
export const IPTC_RIGHTS_ATTRIBUTE_NAME =                     'IPTC - Rights Usage Terms';
export const IPTC_CORE_RIGHTS_ATTRIBUTE_NAME =                'IPTC:Core - Rights Usage Terms';
export const IPTC_SCENE_ATTRIBUTE_NAME =                      'IPTC - Scene';
export const IPTC_CORE_SCENE_ATTRIBUTE_NAME =                 'IPTC:Core - Scene';
export const IPTC_SUBJECT_CODE_ATTRIBUTE_NAME =               'IPTC - Subject Code';
export const IPTC_CORE_SUBJECT_CODE_ATTRIBUTE_NAME =          'IPTC:Core - Subject Code';
export const IS_PANORAMIC_ATTRIBUTE_NAME =                    'com.extensis.portfolio.isPanoramic';
export const JOB_NAME_ATTRIBUTE_NAME =                        'Job Name';
export const JOB_STATUS_ATTRIBUTE_NAME =                      'Job Status';
export const KEYWORDS_ATTRIBUTE_NAME =                        'Keywords';
export const LAST_MODIFIED_ATTRIBUTE_NAME =                   'Last Modified';
export const LAST_UPDATED_ATTRIBUTE_NAME =                    'Last Updated';
export const LOCK_STATUS_ATTRIBUTE_NAME =                     'com.extensis.portfolio.lockStatus';
export const MAC_CREATOR_ATTRIBUTE_NAME =                     'Mac Creator';
export const MAC_FILE_TYPE_ATTRIBUTE_NAME =                   'Mac File Type';
export const MAC_ZONE_ATTRIBUTE_NAME =                        'Mac Zone';
export const MOVIE_AUDIO_CODEC_ATTRIBUTE_NAME =               'Movie - Audio Codec';
export const MOVIE_CHANNELS_ATTRIBUTE_NAME =                  'Movie - Channels';
export const MOVIE_COLOR_DEPTH_ATTRIBUTE_NAME =               'Movie - Color Depth';
export const MOVIE_DURATION_ATTRIBUTE_NAME =                  'Movie - Duration';
export const MOVIE_FPS_ATTRIBUTE_NAME =                       'Movie - FPS';
export const MOVIE_SAMPLE_RATE_ATTRIBUTE_NAME =               'Movie - Sample Rate';
export const MOVIE_SAMPLE_SIZE_ATTRIBUTE_NAME =               'Movie - Sample Size';
export const MOVIE_VIDEO_CODEC_ATTRIBUTE_NAME =               'Movie - Video Codec';
export const MS_AUTHOR_ATTRIBUTE_NAME =                       'MS - Author';
export const MS_COMPANY_ATTRIBUTE_NAME =                      'MS - Company';
export const MS_LAST_SAVED_BY_ATTRIBUTE_NAME =                'MS - Last Saved By';
export const MS_MANAGER_ATTRIBUTE_NAME =                      'MS - Manager';
export const MS_SUBJECT_ATTRIBUTE_NAME =                      'MS - Subject';
export const MS_TEMPLATE_ATTRIBUTE_NAME =                     'MS - Template';
export const MS_TITLE_ATTRIBUTE_NAME =                        'MS - Title';
export const MULTIPAGE_COUNT_ATTRIBUTE_NAME =                 'MultipageCount';
export const NUMBER_OF_BANDS_ATTRIBUTE_NAME =                 'Number of Bands';
export const PATH_ATTRIBUTE_NAME =                            'Path';
export const PHOTOSHOP_LABEL_ATTRIBUTE_NAME =                 'Photoshop Label';
export const PHOTOSHOP_RATING_ATTRIBUTE_NAME =                'Photoshop Rating';
export const PIXELLIVE_AUTHOR_ATTRIBUTE_NAME =                'PixelLive - Author';
export const PIXELLIVE_COMMENTS_ATTRIBUTE_NAME =              'PixelLive - Comments';
export const PIXELLIVE_COPYRIGHT_ATTRIBUTE_NAME =             'PixelLive - Copyright';
export const PIXELLIVE_DATE_ATTRIBUTE_NAME =                  'PixelLive - Date';
export const PIXELLIVE_GENRE_ATTRIBUTE_NAME =                 'PixelLive - Genre';
export const PIXELLIVE_TITLE_ATTRIBUTE_NAME =                 'PixelLive - Title';
export const PLACEHOLDER_ATTRIBUTE_NAME =                     'PlaceHolder';
export const PREVIEW_ATTRIBUTE_NAME =                         'com.extensis.portfolio.Preview';
export const PREVIEW_ERROR_ATTRIBUTE_NAME =                   'com.extensis.portfolio.PreviewError';
export const RID_ATTRIBUTE_NAME =                             'Item ID';
export const ROUTED_TO_ATTRIBUTE_NAME =                       'Routed To';
export const ROUTING_NOTES_ATTRIBUTE_NAME =                   'Routing Notes';
export const SHORT_FILENAME_WIN_ATTRIBUTE_NAME =              'Short Filename Win';
export const SUGGESTED_KEYWORDS_ATTRIBUTE_NAME =              'SuggestedKeywords';
export const THUMBNAIL_ATTRIBUTE_NAME =                       'Thumbnail';
export const THUMBNAIL_SIZE_ATTRIBUTE_NAME =                  'Thumbnail Size';
export const UPDATED_BY_ATTRIBUTE_NAME =                      'Updated By';
export const VERTICAL_RESOLUTION_ATTRIBUTE_NAME =             'Vertical Resolution';
export const VOLUME_ATTRIBUTE_NAME =                          'Volume';
export const WATERMARKED_ATTRIBUTE_NAME =                     'Watermarked';
export const WATERMARK_URL_ATTRIBUTE_NAME =                   'WatermarkURL';
export const WEBSITE_ATTRIBUTE_NAME =                         'Website';
export const WIDTH_ATTRIBUTE_NAME =                           'Width';
export const WORK_NEEDED_ATTRIBUTE_NAME =                     'Work Needed';
export const XMP_ATTRIBUTE_NAME =                             'XMP';

// Use this instead of 'Asset ID' when talking to the server
export const RID_ATTRIBUTE_NAME_FOR_SERVER =                  'RID';

// These fields are taken from the express app
// not sure if all of them are still used
export const Messages = defineMessages({
  Cataloged: {
    id: 'FIELD_DEF.cataloged',
    defaultMessage: 'Cataloged',
  },
  'Cataloged By': {
    id: 'FIELD_DEF.catalogedBy',
    defaultMessage: 'Cataloged By',
  },
  'Color Mode': {
    id: 'FIELD_DEF.colorMode',
    defaultMessage: 'Color Mode',
  },
  'com.extensis.portfolio.isPanoramic': {
    id: 'FIELD_DEF.isPanoramic',
    defaultMessage: 'Panoramic',
  },
  Created: {
    id: 'FIELD_DEF.created',
    defaultMessage: 'Created',
  },
  'Directory Path': {
    id: 'FIELD_DEF.directoryPath',
    defaultMessage: 'Directory Path',
  },
  'Document Text': {
    id: 'FIELD_DEF.documentText',
    defaultMessage: 'Document Text',
  },
  'Extension Win': {
    id: 'FIELD_DEF.ExtensionWin',
    defaultMessage: 'Extension',
  },
  Filename: {
    id: 'FIELD_DEF.filename',
    defaultMessage: 'Filename',
  },
  'File Description': {
    id: 'FIELD_DEF.fileDescription',
    defaultMessage: 'Description',
  },
  'File Size': {
    id: 'FIELD_DEF.fileSize',
    defaultMessage: 'File Size',
  },
  'Geometry': {
    id: 'FIELD_DEF.geometry',
    defaultMessage: 'Geo - Map',
  },
  Height: {
    id: 'FIELD_DEF.height',
    defaultMessage: 'Height',
  },
  'Horizontal Resolution': {
    id: 'FIELD_DEF.horizontalResolution',
    defaultMessage: 'Horizontal Resolution',
  },
  Keywords: {
    id: 'FIELD_DEF.keywords',
    defaultMessage: 'Keywords',
  },
  'Last Modified': {
    id: 'FIELD_DEF.lastModified',
    defaultMessage: 'Modified',
  },
  'Last Updated': {
    id: 'FIELD_DEF.lastUpdated',
    defaultMessage: 'Changed',
  },
  'Alias Mac': {
    id: 'FIELD_DEF.aliasMac',
    defaultMessage: 'Alias Mac',
  },
  'Creator Mac': {
    id: 'FIELD_DEF.creatorMac',
    defaultMessage: 'Creator Mac',
  },
  'File Type Mac': {
    id: 'FIELD_DEF.fileTypeMac',
    defaultMessage: 'File Type Mac',
  },
  'Zone Mac': {
    id: 'FIELD_DEF.zoneMac',
    defaultMessage: 'Zone Mac',
  },
  MultipageCount: {
    id: 'FIELD_DEF.multipageCount',
    defaultMessage: 'Number of Pages',
  },
  'Number of Bands': {
    id: 'FIELD_DEF.numBands',
    defaultMessage: 'Number of Bands',
  },
  Path: {
    id: 'FIELD_DEF.path',
    defaultMessage: 'Path',
  },
  'Item ID': {
    id: 'FIELD_DEF.ItemID',
    defaultMessage: 'Asset ID',
  },
  'Short Filename Win': {
    id: 'FIELD_DEF.shortFilenameWin',
    defaultMessage: 'Short Filename Win',
  },
  'Thumbnail Size': {
    id: 'FIELD_DEF.thumbnailSize',
    defaultMessage: 'Thumbnail Size',
  },
  'Updated By': {
    id: 'FIELD_DEF.updatedBy',
    defaultMessage: 'Changed By',
  },
  'Vertical Resolution': {
    id: 'FIELD_DEF.verticalResolution',
    defaultMessage: 'Vertical Resolution',
  },
  Volume: {
    id: 'FIELD_DEF.volume',
    defaultMessage: 'Volume',
  },
  Watermarked: {
    id: 'FIELD_DEF.watermarked',
    defaultMessage: 'Watermarked',
  },
  'Watermark URL': {
    id: 'FIELD_DEF.watermarkURL',
    defaultMessage: 'Watermark URL',
  },
  Width: {
    id: 'FIELD_DEF.width',
    defaultMessage: 'Width',
  },
  SuggestedKeywords: {
    id: 'FIELD_DEF.SuggestedKeywords',
    defaultMessage: 'Smart Keywords',
  }
});

// Non "Displayable" Fields, e.g. not in asset grid/list or fields panel
export const EXCLUDED_FIELDS = [
  'CorruptFile',
  'Document Text',
  'Flags',
  'FullyCataloged',
  'PlaceHolder',
  'RID',
  'SuggestedKeywords',
  'Thumbnail',
  'Centroid',
];

export const FIELD_TYPE = {
  STRING: 0,
  NUMBER: 1,
  DECIMAL: 2,
  DATETIME: 3,
  URL: 4,
  TEXTBLOCK: 5,
  BINARY: 6,
  BOOLEAN: 7,
  GEOJSON: 8,
  UNKNOWN: 99,
};

// synthetic Item ID field (refers to asset id)
export const ITEM_ID = {
  'systemName': RID_ATTRIBUTE_NAME,
  'type': FIELD_TYPE.STRING,
  'isSystem': true,
  'isMultivalued': false,
  'isSortable': true,
  'isSearchable': true,
};

export const SYSTEM_FIELDS = {
  Cataloged: CATALOGED_ATTRIBUTE_NAME,
  ColorMode: COLOR_MODE_ATTRIBUTE_NAME,
  DirectoryPath: DIR_PATH_ATTRIBUTE_NAME,
  FileSize: FILE_SIZE_ATTRIBUTE_NAME,
  Filename: FILENAME_ATTRIBUTE_NAME,
  Height: HEIGHT_ATTRIBUTE_NAME,
  HorizontalResolution: HORIZONTAL_RESOLUTION_ATTRIBUTE_NAME,
  ItemID: RID_ATTRIBUTE_NAME,
  Keywords: KEYWORDS_ATTRIBUTE_NAME,
  NumberOfBands: NUMBER_OF_BANDS_ATTRIBUTE_NAME,
  Path: PATH_ATTRIBUTE_NAME,
  Thumbnail: THUMBNAIL_ATTRIBUTE_NAME,
  ThumbnailSize: THUMBNAIL_SIZE_ATTRIBUTE_NAME,
  VerticalResolution: VERTICAL_RESOLUTION_ATTRIBUTE_NAME,
  Width: WIDTH_ATTRIBUTE_NAME,
  LastUpdated: LAST_UPDATED_ATTRIBUTE_NAME,
  Geometry: GEOMETRY_ATTRIBUTE_NAME,
  SuggestedKeywords: SUGGESTED_KEYWORDS_ATTRIBUTE_NAME,

  // Special pseudo fields
  LockStatus: LOCK_STATUS_ATTRIBUTE_NAME,
  CheckOutStatus: CHECK_OUT_STATUS_ATTRIBUTE_NAME,
  PreviewStatus: 'com.extensis.portfolio.stillPreviewStatus',
  isPanoramic: IS_PANORAMIC_ATTRIBUTE_NAME,
  AVPreviewStatus: AV_PREVIEW_STATUS_ATTRIBUTE_NAME,
};

// values for avPreviewStatus
export const AV_PREVIEW_STATUS_NONE  = 'none';
export const AV_PREVIEW_STATUS_PENDING = 'pending';
export const AV_PREVIEW_STATUS_READY  = 'ready';

// Fields which most asset views want, even if the user does not explicitly choose them
export const STANDARD_FIELDS_TO_RETRIEVE = [
  SYSTEM_FIELDS.Path,
  SYSTEM_FIELDS.LockStatus,
  SYSTEM_FIELDS.CheckOutStatus,
  SYSTEM_FIELDS.Filename,
  SYSTEM_FIELDS.LastUpdated,
  SYSTEM_FIELDS.Geometry,
  SYSTEM_FIELDS.isPanoramic,
  SYSTEM_FIELDS.Width,
  SYSTEM_FIELDS.Height,
  SYSTEM_FIELDS.AVPreviewStatus,
  SYSTEM_FIELDS.SuggestedKeywords,
];

export const SYSTEM_DATE_FIELDS = [
  CATALOGED_ATTRIBUTE_NAME,
  CREATED_ATTRIBUTE_NAME,
  LAST_MODIFIED_ATTRIBUTE_NAME,
  LAST_UPDATED_ATTRIBUTE_NAME,
];

export const ALL_KNOWN_READ_ONLY_FIELD_DEF_NAMES = [
  BIT_DEPTH_ATTRIBUTE_NAME, CATALOGED_ATTRIBUTE_NAME, CATALOGED_BY_ATTRIBUTE_NAME,
  COLOR_MODE_ATTRIBUTE_NAME, COLOR_PROFILE_ATTRIBUTE_NAME, CREATED_ATTRIBUTE_NAME,
  CUSTOM_THUMBNAIL_ATTRIBUTE_NAME, DIR_PATH_ATTRIBUTE_NAME, EXTENSION_WIN_ATTRIBUTE_NAME,
  FILE_SIZE_ATTRIBUTE_NAME, GEOMETRY_ATTRIBUTE_NAME, GEO_COORDINATE_REF_ATTRIBUTE_NAME,
  GEO_X_ORIGIN_ATTRIBUTE_NAME, GEO_Y_ORIGIN_ATTRIBUTE_NAME, GEO_X_RES_ATTRIBUTE_NAME,
  GEO_Y_RES_ATTRIBUTE_NAME, GEO_X_ROT_ATTRIBUTE_NAME, GEO_Y_ROT_ATTRIBUTE_NAME,
  GEO_NATIVE_BOUNDS_ATTRIBUTE_NAME, GEO_WGS84_BOUNDS_ATTRIBUTE_NAME, GEO_EPGS_CODE_ATTRIBUTE_NAME,
  GEO_TYPE_ATTRIBUTE_NAME, HEIGHT_ATTRIBUTE_NAME, HORIZONTAL_RESOLUTION_ATTRIBUTE_NAME,
  IS_PANORAMIC_ATTRIBUTE_NAME, LAST_MODIFIED_ATTRIBUTE_NAME, LAST_UPDATED_ATTRIBUTE_NAME,
  MAC_CREATOR_ATTRIBUTE_NAME, MAC_FILE_TYPE_ATTRIBUTE_NAME, MAC_ZONE_ATTRIBUTE_NAME,
  MULTIPAGE_COUNT_ATTRIBUTE_NAME, NUMBER_OF_BANDS_ATTRIBUTE_NAME, PATH_ATTRIBUTE_NAME, RID_ATTRIBUTE_NAME,
  SHORT_FILENAME_WIN_ATTRIBUTE_NAME, THUMBNAIL_ATTRIBUTE_NAME, THUMBNAIL_SIZE_ATTRIBUTE_NAME,
  UPDATED_BY_ATTRIBUTE_NAME, VERTICAL_RESOLUTION_ATTRIBUTE_NAME, VOLUME_ATTRIBUTE_NAME,
  WATERMARKED_ATTRIBUTE_NAME, WATERMARK_URL_ATTRIBUTE_NAME, WIDTH_ATTRIBUTE_NAME,
  XMP_ATTRIBUTE_NAME
];

export const DEFAULT_SORT_FIELD = CATALOGED_ATTRIBUTE_NAME;

/*
*  Returns an array of user facing field defs for display in the UI
*/
export function getAllDisplayableFields(fieldDefs) {
  if (fieldDefs) {
    // remove the excluded fields
    const displayableFields = fieldDefs.filter(fieldDef => !EXCLUDED_FIELDS.includes(fieldDef.systemName));

    // add in the item id field
    displayableFields.push(ITEM_ID);

    return displayableFields;
  }
}

export function getAdvancedFindFields(fieldDefs) {
  if (fieldDefs) {
    const exclusions = [
      CORRUPT_FILE_ATTRIBUTE_NAME,
      FLAGS_ATTRIBUTE_NAME,
      FULLY_CATALOGED_ATTRIBUTE_NAME,
      PLACEHOLDER_ATTRIBUTE_NAME,
      RID_ATTRIBUTE_NAME_FOR_SERVER,
    ];
    fieldDefs = fieldDefs.filter(fieldDef => fieldDef.isSearchable && !exclusions.includes(fieldDef.systemName));
    fieldDefs.push(ITEM_ID);
    return fieldDefs;
  }
}

export const CHECKOUT_STATUS_INDEXES = {
  CHECKOUT_STATUS_INDEX_USER_SHORT_NAME: 1,
  CHECKOUT_STATUS_INDEX_DATETIME: 3,
};

export function getCheckoutStatus(asset) {
  if (asset && asset.attributes) {
    return asset.attributes[SYSTEM_FIELDS.CheckOutStatus];
  }
}

export function getCheckoutStatusUserShortName(checkoutStatus) {
  if (checkoutStatus) {
    return checkoutStatus[CHECKOUT_STATUS_INDEXES.CHECKOUT_STATUS_INDEX_USER_SHORT_NAME];
  }
}

export function getCheckoutStatusDateTime(checkoutStatus) {
  if (checkoutStatus) {
    return checkoutStatus[CHECKOUT_STATUS_INDEXES.CHECKOUT_STATUS_INDEX_DATETIME];
  }
}

export function caseInsensitiveContains(predicate, subject) {
  if (!predicate) {
    return true;
  }

  const a = subject.toLowerCase();
  const b = predicate.toLowerCase();
  const noMatch = a.indexOf(b) === -1;

  if (noMatch) {
    return false;
  }

  return true;
};

export function findFieldIndex(haystack, needle) {
  return haystack ? haystack.findIndex(el => el.systemName === needle.systemName) : -1;
}

export function getFieldDefByName(fieldDefs, fieldName) {
  if (fieldName === SYSTEM_FIELDS.ItemID) {
    return ITEM_ID;
  } else {
    return fieldDefs.find(e => e.systemName === fieldName);
  }
}

export function getFieldDefById(fieldDefs, id) {
  const fd = fieldDefs.find(e => e.id === id);
  if (fd && fd.systemName === RID_ATTRIBUTE_NAME_FOR_SERVER) {
    return ITEM_ID;
  }

  return fd;
}

export function getIdsForFieldDefs(fieldDefs, fds) {
  return fds.map(fd => fd.systemName === RID_ATTRIBUTE_NAME ? getFieldDefByName(fieldDefs, RID_ATTRIBUTE_NAME_FOR_SERVER).id : fd.id);
}

export function isSystemField(fieldName, fieldDefs) {
  let result = false;

  if (fieldName && fieldDefs) {
    const field = fieldDefs.find(fieldDef => fieldDef.systemName === fieldName);
    result = (field) ? field.isSystem : false;
  }

  return result;
}

export function getFieldTypeName(fieldType) {
  return Object.keys(FIELD_TYPE)
    .find(k => FIELD_TYPE[k] === fieldType);
}

export function getPredefinedValuesForFieldDef(fieldDef, flattenNestedValues = false) {
  let predefinedValues = null;
  if (fieldDef && fieldDef.hasPredefinedValues) {
    if (fieldDef.isHierarchical) {
      predefinedValues = (fieldDef.nestedPredefinedValues && fieldDef.nestedPredefinedValues.length > 0) ? fieldDef.nestedPredefinedValues : null;
      if (predefinedValues && flattenNestedValues) {
        predefinedValues = _getArrayFromNestedValues(predefinedValues);
      }
    } else {
      predefinedValues = (fieldDef.predefinedValues && fieldDef.predefinedValues.length > 0) ? fieldDef.predefinedValues : null;
    }
  }

  if (predefinedValues &&
     (!fieldDef.isHierarchical || (fieldDef.isHierarchical && flattenNestedValues))) {
    predefinedValues.sort((a, b) => a.localeCompare(b));
  }

  return predefinedValues;
}

export function multivalueCompareFn(fieldDef, sampleValue) {
  switch (fieldDef.type) {
    case FIELD_TYPE.STRING:
      return (a, b) => a.localeCompare(b);
    case FIELD_TYPE.DATETIME:
      return (a, b) => new Date(a) - new Date(b);
    case FIELD_TYPE.URL:
      return (a, b) => 0; // don't sort at all
    case FIELD_TYPE.NUMBER:
    case FIELD_TYPE.DECIMAL:
      if (typeof sampleValue === 'string') {
        return (a, b) => Number(a) - Number(b);
      }
      // fall through
    case FIELD_TYPE.TEXTBLOCK:
    case FIELD_TYPE.BINARY:
    default:
      return (a, b) => a - b;
  }
}

export function sortValuesForFieldDef(fieldDef, values) {
  if (!fieldDef || !values || values.length === 0) {
    return;
  }
  switch (fieldDef.type) {
    case FIELD_TYPE.STRING:
    case FIELD_TYPE.NUMBER:
    case FIELD_TYPE.DECIMAL:
    case FIELD_TYPE.DATE:
    default:
      values.sort(multivalueCompareFn(fieldDef, values[0]));
      break;
    // Not interested in sorting other types.
  }
}

function _getArrayFromNestedValues(nestedValues, values = []) {
  nestedValues.forEach((nestedValue) => {
    values.push(nestedValue.value);
    if (nestedValue.children && nestedValue.children.length > 0) {
      _getArrayFromNestedValues(nestedValue.children, values);
    }
  });
  return values;
}



// WEBPACK FOOTER //
// ./src/portfolio-shared/util/fieldDefUtils.js